import { render } from "./buy_product.vue?vue&type=template&id=732859d4"
import script from "./buy_product.vue?vue&type=script&lang=js"
export * from "./buy_product.vue?vue&type=script&lang=js"

import exportComponent from "/vuebuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__